import * as THREE from 'three';
import { renderManager } from './globals.js';
import { initReefsPopup } from "./reefs_list/reefs_list.js";

import {
  initHomeAudio,
  startHomeAudio,
  stopHomeAudio,
  createHomeAudioControls,
  createHomeOverlay,
  fadeOutHomeAudio
} from "./audio_manager/audio.js";

// 🎧 AUDIO HOME: Inicialización silenciosa en memoria
initHomeAudio();

/**
 * 🛠️ Función auxiliar para renderizar los controles y reproducir el audio.
 * Se llama únicamente cuando el usuario hace clic en "START NOW".
 */
function activarAudioYControles() {
    // 1. Iniciar la reproducción del audio de fondo
    if (typeof startHomeAudio === 'function') {
        startHomeAudio();
    }

    // 2. Crear y añadir el overlay de desbloqueo (si es necesario por la lógica de tu audio.js)
    const overlay = createHomeOverlay();
    if (overlay) {
        document.body.appendChild(overlay);
    }

    // 3. Crear y hacer visibles los controles de audio en el DOM
    if (!document.getElementById("home-audio-controls")) {
        const controls = createHomeAudioControls();
        if (controls) {
            controls.id = "home-audio-controls";
            // Opcional: Puedes meter estilos inline aquí para asegurar una transición suave si tu CSS no la tiene
            controls.style.opacity = '0';
            controls.style.transition = 'opacity 0.5s ease';
            
            document.body.appendChild(controls);
            
            // Forzar reflow para que el navegador aplique la transición de desvanecimiento
            setTimeout(() => { controls.style.opacity = '1'; }, 50);
        }
    }
}


// =========================================================================
// 🛸 DRON CINEMÁTICO: CON SECUENCIA DE TEXTOS DINÁMICOS Y BOTÓN "START NOW"
// =========================================================================

const posicionesRaw = [
    new THREE.Vector3(-0.03667968095639873, 0.058440448154549546, -0.5380427186252753),
    new THREE.Vector3(-0.09644487058566131, 0.05844026891946269, -0.4424738026262218),
    new THREE.Vector3(-0.15988660347646838, 0.058440266392173895, -0.34076685155196235),
    new THREE.Vector3(-0.2051977233242269, 0.03456285550539745, -0.24312641643174465),
    new THREE.Vector3(-0.23358781042589002, 0.03424434236938928, -0.19097378276519866),
    new THREE.Vector3(-0.2731600667686481, 0.03423905144802952, -0.11894741005018017),
    new THREE.Vector3(-0.3092760731559414, 0.03423899313250103, -0.05272368646599762),
    new THREE.Vector3(-0.32688314435634425, 0.03423899283640852, 0.006061089965821165),
    new THREE.Vector3(-0.33536113016101776, 0.0342389928349813, 0.06449896741078814),
    new THREE.Vector3(-0.33782762418702084, 0.034238992834969645, 0.15744096192846901),
    new THREE.Vector3(-0.3368621809259849, 0.03423899283496473, 0.2426771134963024)
];

const targetsRaw = [
    new THREE.Vector3(-0.21134551955624648, -0.16739687879186782, -0.12756818870891107),
    new THREE.Vector3(-0.2711102618357303, -0.1673968818966109, -0.031998977075691666),
    new THREE.Vector3(-0.3345519883848606, -0.16739688189661178, 0.06970797808755676),
    new THREE.Vector3(-0.37921113926766753, -0.16739688189661234, 0.1798766515715575),
    new THREE.Vector3(-0.4075987539529725, -0.16739688189661323, 0.23218222653789772),
    new THREE.Vector3(-0.44717096820434055, -0.167396881896614, 0.3042111377374927),
    new THREE.Vector3(-0.48328697412752425, -0.16739688189661495, 0.3704348892999919),
    new THREE.Vector3(-0.5008940453255707, -0.16739688189661545, 0.42921966587386795),
    new THREE.Vector3(-0.5093720311302324, -0.167396881896616, 0.48765754331951955),
    new THREE.Vector3(-0.5118385251562366, -0.16739688189662058, 0.5805995378372033),
    new THREE.Vector3(-0.5108730818952008, -0.16739688189662552, 0.6658356894050366)
];

const posicionFinalClick = new THREE.Vector3(-0.428256190218853, 0.10549553746097787, 0.4226036680335491);
const targetFinalClick = new THREE.Vector3(-0.2605737442010652, -0.1187037834510277, 0.008336529815384065);

const curvaPosicion = new THREE.CatmullRomCurve3(posicionesRaw, false, 'centripetal');
const curvaTarget = new THREE.CatmullRomCurve3(targetsRaw, false, 'centripetal');

let estadoAnimacion = 'CURVA'; 
let progresoTiempo = 0; 
let lastTime = performance.now();
let yaInicializado = false;

const tempPos = new THREE.Vector3();
const tempTar = new THREE.Vector3();
const lastPos = new THREE.Vector3();

let smoothedRoll = 0;
let smoothedPitch = 0;
const microViento = { x: 0, y: 0 };

let domOverlay = null;
let domTextoLoading = null;
let domTextoNodo = null; 
let domLogo = null;

const secuenciaTextos = [
    "Welcome to Cozumel Reef Maps",
    "Preparing the 3D environment...",
    "Explore the reefs in full 3D",
    "Select a dive site from the list",
    "And enjoy your virtual reef tour"
];

function crearInterfaceCarga() {
    if (document.getElementById('drone-loading-overlay')) return;

    if (!document.getElementById('drone-font-link')) {
        const link = document.createElement('link');
        link.id = 'drone-font-link';
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap';
        document.head.appendChild(link);
    }

    domOverlay = document.createElement('div');
    domOverlay.id = 'drone-loading-overlay';
    
    Object.assign(domOverlay.style, {
        position: 'absolute',
        top: '50%',
        left: '50%',
        height: '100%',
        width: '100%',
        transform: 'translate(-50%, -50%)',
        padding: '25px 45px',
        backgroundColor: 'rgba(12, 33, 56, 0.6)',
        backdropFilter: 'blur(0.5px)',
        webkitBackdropFilter: 'blur(0.5px)',
        borderRadius: '16px',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        boxShadow: 'rgba(0, 0, 0, 0.4) 0px 20px 40px, rgba(255, 255, 255, 0.1) 0px 1px 0px inset',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        zIndex: '99999',
        fontFamily: 'Montserrat, "Segoe UI", sans-serif',
        transition: 'opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
        pointerEvents: 'auto',
        opacity: '1'
    });

    domLogo = document.createElement('img');
    domLogo.src = 'https://cozumel-reef-maps.com.mx/Views/Default/img/logo_circle.png'; 
    domLogo.alt = 'Logo';
    Object.assign(domLogo.style, {
        width: '75px', 
        height: 'auto',
        objectFit: 'contain',
        animation: 'dronePulse 2.5s ease-in-out infinite',
        userSelect: 'none',
        pointerEvents: 'none'
    });

    domTextoLoading = document.createElement('div');
    domTextoLoading.id = 'drone-status-container';
    
    Object.assign(domTextoLoading.style, {
        color: '#ffffff',
        fontSize: '16px', 
        fontWeight: '600',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        textShadow: '0 2px 8px rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease',
        textAlign: 'center',
        maxWidth: '85%',
        lineHeight: '1.4'
    });

    domTextoNodo = document.createElement('span');
    domTextoNodo.innerText = secuenciaTextos[0];

    if (!document.getElementById('drone-style-defs')) {
        const styleSheet = document.createElement('style');
        styleSheet.id = 'drone-style-defs';
        styleSheet.type = 'text/css';
        styleSheet.innerText = `
            @keyframes dronePulse { 0%, 100% { opacity: 0.7; transform: scale(0.97); } 50% { opacity: 1; transform: scale(1.03); } }
            .btn-start-now:hover { 
                background: #ffffff !important;
                color: #0c2138 !important;
                transform: scale(1.05);
                box-shadow: 0 8px 25px rgba(0,0,0,0.3) !important;
            }
        `;
        document.head.appendChild(styleSheet);
    }

    domTextoLoading.appendChild(domTextoNodo);
    domOverlay.appendChild(domLogo);       
    domOverlay.appendChild(domTextoLoading); 
    
    const contenedorCanvas = renderManager?.renderer?.domElement?.parentElement || document.body;
    contenedorCanvas.style.position = 'relative'; 
    contenedorCanvas.appendChild(domOverlay);
}

function actualizarTextoSecuencia(progreso) {
    if (!domTextoNodo || estadoAnimacion !== 'CURVA') return;
    
    const totalTextos = secuenciaTextos.length;
    const indice = Math.min(Math.floor(progreso * totalTextos), totalTextos - 1);
    
    if (domTextoNodo.innerText !== secuenciaTextos[indice]) {
        domTextoNodo.innerText = secuenciaTextos[indice];
    }
}

function transformarEnBotonStart() {
    if (!domTextoLoading || estadoAnimacion !== 'CURVA') return;
    estadoAnimacion = 'QUIETO'; 

    if (domLogo) domLogo.style.animation = 'none';

    domTextoLoading.innerHTML = '';
    domTextoLoading.innerText = 'START NOW';
    domTextoLoading.className = 'btn-start-now';

    Object.assign(domTextoLoading.style, {
        cursor: 'pointer',
        padding: '14px 45px',
        fontSize: '16px',
        fontWeight: '700',
        letterSpacing: '2.5px',
        color: '#ffffff',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        border: '2px solid #ffffff',
        borderRadius: '30px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
        display: 'inline-block',
        textAlign: 'center',
        transition: 'all 0.3s ease'
    });

    domTextoLoading.onclick = () => {
        // 🎵 🔥 EJECUTAR AUDIO, CREAR OVERLAY Y MOSTRAR CONTROLES AL DAR CLICK AQUÍ
        activarAudioYControles();

        // 1. Empezamos a desvanecer suavemente el overlay azul del dron
        domOverlay.style.opacity = '0';
        
        renderManager.camera.position.copy(posicionFinalClick);
        renderManager.controls.target.copy(targetFinalClick);
        renderManager.camera.rotation.set(0, 0, 0); 
        renderManager.controls.update();

        estadoAnimacion = 'TERMINADO'; 
        
        // 2. Esperamos exactamente los 800ms de la transición CSS para que desaparezca del todo
        setTimeout(() => {
            domOverlay.remove();
            console.log("Simulador iniciado de forma inmediata.");
            
            // 3. Justo aquí lanzamos el Popup inicial de forma limpia y fluida
            if (typeof initReefsPopup === 'function') {
                initReefsPopup();
                
                const popupContainer = document.querySelector('.reefs-popup-container') || document.getElementById('reefs-popup');
                if (popupContainer) {
                    popupContainer.style.opacity = '0';
                    popupContainer.style.transition = 'opacity 0.6s ease';
                    setTimeout(() => { popupContainer.style.opacity = '1'; }, 50);
                }
            }
        }, 800); 
    };
}

export function vueloInicial() {
    if (estadoAnimacion === 'TERMINADO') return;

    if (!renderManager || !renderManager.camera || !renderManager.controls) {
        requestAnimationFrame(vueloInicial);
        return;
    }

    const now = performance.now();
    const deltaTime = (now - lastTime) / 1000;
    lastTime = now;

    if (!yaInicializado) {
        crearInterfaceCarga(); 

        curvaPosicion.getPointAt(0, tempPos);
        curvaTarget.getPointAt(0, tempTar);
        lastPos.copy(tempPos);
        renderManager.camera.position.copy(tempPos);
        renderManager.controls.target.copy(tempTar);
        renderManager.controls.update();
        yaInicializado = true;
    }

    if (estadoAnimacion === 'CURVA') {
        const VELOCIDAD_LINEAS = 0.045; 
        progresoTiempo = Math.min(progresoTiempo + (VELOCIDAD_LINEAS * deltaTime), 1);

        actualizarTextoSecuencia(progresoTiempo);

        curvaPosicion.getPointAt(progresoTiempo, tempPos);
        curvaTarget.getPointAt(progresoTiempo, tempTar);

        const direccionAvance = new THREE.Vector3().subVectors(tempPos, lastPos);
        if (direccionAvance.lengthSq() > 0.00001) {
            direccionAvance.normalize();
            const vectorLateral = new THREE.Vector3(-direccionAvance.z, 0, direccionAvance.x);
            const deltaDireccionLateral = vectorLateral.dot(new THREE.Vector3().subVectors(tempTar, renderManager.controls.target));

            const targetRoll = deltaDireccionLateral * (VELOCIDAD_LINEAS * 15); 
            smoothedRoll = THREE.MathUtils.lerp(smoothedRoll, targetRoll, 0.05);
            smoothedPitch = THREE.MathUtils.lerp(smoothedPitch, 0.002, 0.04);
        }

        microViento.x = Math.sin(now * 0.004) * 0.0003;
        microViento.y = Math.cos(now * 0.003) * 0.0002;

        lastPos.copy(tempPos);

        renderManager.camera.position.copy(tempPos);
        renderManager.camera.position.x += microViento.x;
        renderManager.camera.position.y += microViento.y;

        if (progresoTiempo >= 0.98) {
            renderManager.controls.target.copy(tempTar);
            smoothedRoll = THREE.MathUtils.lerp(smoothedRoll, 0, 0.1);
            smoothedPitch = THREE.MathUtils.lerp(smoothedPitch, 0, 0.1);
        } else {
            renderManager.controls.target.lerp(tempTar, 0.06);
        }
        
        renderManager.controls.update();

        renderManager.camera.rotation.z = -smoothedRoll;
        renderManager.camera.rotation.x -= smoothedPitch;

        if (progresoTiempo >= 1) {
            renderManager.camera.rotation.set(0, renderManager.camera.rotation.y, 0);
            renderManager.controls.target.copy(tempTar);
            renderManager.controls.update();
            transformarEnBotonStart();
        }
        
        requestAnimationFrame(vueloInicial);
    } 
    else if (estadoAnimacion === 'QUIETO') {
        requestAnimationFrame(vueloInicial);
    }
}